import React from "react"
import {WelcomeAccountPage} from "./components/WelcomeAccountPage"

export const ResetPasswordComplete: React.FC = (): React.ReactElement => {
  return <WelcomeAccountPage>
    <>Password reset completed</>
  </WelcomeAccountPage>
}